//todo: ทำ enum ของ direction
class SortBy {
    Name: string;
    Direction: number
}

export default SortBy;